import { render, staticRenderFns } from "./OP_PERF_TRGTS.vue?vue&type=template&id=52f55b3c&scoped=true"
import script from "./OP_PERF_TRGTS.vue?vue&type=script&lang=ts"
export * from "./OP_PERF_TRGTS.vue?vue&type=script&lang=ts"
import style0 from "./OP_PERF_TRGTS.vue?vue&type=style&index=0&id=52f55b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f55b3c",
  null
  
)

export default component.exports